(function(){
  if(window.__L4MInlineProductGallery) return;
  window.__L4MInlineProductGallery=true;
  const mq=window.matchMedia('(max-width: 749px)');

  function initPaged(root){
    if(!root || root.dataset.l4mInlineInit==='1') return;
    root.dataset.l4mInlineInit='1';
    const track=root.querySelector('[data-l4m-inline-track]');
    const pages=[...root.querySelectorAll('[data-l4m-inline-page]')];
    const media=[...root.querySelectorAll('[data-l4m-inline-media]')];
    const prev=root.querySelector('[data-l4m-inline-prev]');
    const next=root.querySelector('[data-l4m-inline-next]');
    const current=root.querySelector('[data-l4m-inline-current]');
    let page=0;
    function pauseVideos(){root.querySelectorAll('video').forEach(v=>{if(!v.closest('.l4m-pdp-hero__gallery-page')?.classList.contains('is-current')){try{v.pause()}catch(e){}}});}
    function render(){
      if(mq.matches){track.style.transform='';return;}
      page=Math.max(0,Math.min(page,pages.length-1));
      track.style.transform=`translate3d(${-page*100}%,0,0)`;
      pages.forEach((p,i)=>p.classList.toggle('is-current',i===page));
      if(prev) prev.disabled=page===0;
      if(next) next.disabled=page===pages.length-1;
      if(current) current.textContent=String(Math.min(page*5+1,media.length));
      pauseVideos();
    }
    prev?.addEventListener('click',()=>{page--;render()});
    next?.addEventListener('click',()=>{page++;render()});
    track?.addEventListener('scroll',()=>{
      if(!mq.matches || !media.length) return;
      let best=0,bestDist=Infinity;
      const left=track.scrollLeft+track.clientWidth/2;
      media.forEach((el,i)=>{const c=el.offsetLeft+el.offsetWidth/2,d=Math.abs(c-left);if(d<bestDist){bestDist=d;best=i;}});
      if(current) current.textContent=String(best+1);
    },{passive:true});
    mq.addEventListener?.('change',()=>{page=0;render()});
    render();
  }

  function cloneSwap(root,index){
    const stage=root.querySelector('[data-l4m-swap-stage]');
    const tpl=root.querySelector(`template[data-l4m-swap-item][data-media-index="${index}"]`);
    if(!stage||!tpl)return;
    stage.querySelectorAll('video').forEach(v=>{try{v.pause()}catch(e){}});
    stage.innerHTML=''; stage.appendChild(tpl.content.cloneNode(true));
    root.querySelectorAll('[data-l4m-swap-thumb]').forEach((b,i)=>{
      const active=Number(b.dataset.mediaIndex)===Number(index);
      b.classList.toggle('is-active',active); b.setAttribute('aria-current',active?'true':'false');
    });
  }
  function initSwap(root){
    if(!root || root.dataset.l4mSwapInit==='1') return;
    root.dataset.l4mSwapInit='1';
    root.addEventListener('click',e=>{const b=e.target.closest('[data-l4m-swap-thumb]');if(!b||!root.contains(b))return;e.preventDefault();cloneSwap(root,b.dataset.mediaIndex);});
  }
  function loadExternalVideo(button){
    const root=button?.closest('[data-l4m-external-video]');
    const tpl=root?.querySelector('template[data-l4m-external-video-template]');
    if(!root||!tpl) return;
    const frag=tpl.content.cloneNode(true);
    root.replaceChildren(frag);
  }

  document.addEventListener('click',e=>{
    const button=e.target.closest('[data-l4m-external-video-play]');
    if(!button) return;
    e.preventDefault();
    loadExternalVideo(button);
  });

  function boot(){
    document.querySelectorAll('[data-l4m-inline-gallery]').forEach(initPaged);
    document.querySelectorAll('[data-org-gallery],.rl-gallery,.sl-gallery').forEach(initSwap);
  }
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',boot):boot();
  document.addEventListener('shopify:section:load',boot);
})();